<template>
  <span
    :class="`mc-badge ${computedVariant} ${computedSize} ${computedType}`"
    :style="computedStyle"
  >
    <span v-if="withDot" :class="['mc-badge-dot', computedDotColor]"></span>

    <i v-if="icon" :class="`${icon} ${computedIconVariant} mc-badge-icon`"></i>

    <span v-if="text">{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'medium',
    },
    type: {
      type: String,
      default: 'button',
      required: true,
    },
    color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconVariant: {
      type: String,
      default: null,
    },
    withDot: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedVariant() {
      const variantMapping = {
        primary: 'bg-primary',
        secondary: 'bg-secondary',
        success: 'bg-success',
        danger: 'bg-danger',
        warning: 'bg-warning',
        info: 'bg-info',
        light: 'bg-light',
        dark: 'bg-dark',
        pink: 'bg-pink',
        purple: 'bg-purple',
        canceled: 'bg-canceled',
        inprogress: 'bg-progress',
        draft: 'bg-draft',
        confirm: 'bg-confirm',
        picked: 'bg-confirm',
        confirmOrder: 'bg-confirm-order',
        scheduled: 'bg-scheduled',
        scheduledOrder: 'bg-rescheduled-order',
        rescheduled: 'bg-rescheduled',
        rescheduledOrder: 'bg-rescheduled-order',
        started: 'bg-started',
        delivered: 'bg-delivered',
        break: 'bg-break-time',
        idle: 'bg-idle-time',
        outlinePrimary: 'mc-outline-primary',
        outlineSecondary: 'mc-outline-secondary',
        outlineSuccess: 'mc-outline-success',
        outlineDanger: 'mc-outline-danger',
        outlineWarning: 'mc-outline-warning',
        outlineInfo: 'mc-outline-info',
        outlineDark: 'bg-outline-dark',
        outlinePink: 'mc-outline-pink',
        outlinePurple: 'mc-outline-purple',
        outlinePlain: 'bg-outline-plain',
        outlinePlainSecondary: 'bg-outline-plain-secondary',
      }
      return variantMapping[this.variant] || 'bg-primary'
    },

    computedIconVariant() {
      const variantMapping = {
        primary: 'icon-primary',
        secondary: 'icon-secondary',
        success: 'icon-success',
        danger: 'icon-danger',
        warning: 'icon-warning',
      }
      return variantMapping[this.iconVariant] || ''
    },

    computedSize() {
      const sizeMapping = {
        small: 'mc-badge--small',
        medium: 'mc-badge--medium',
        large: 'mc-badge--large',
      }
      return sizeMapping[this.size] || 'mc-badge--medium'
    },

    computedType() {
      const typeMapping = {
        pill: 'mc-badge--pill',
        button: 'mc-badge--button',
        status: 'mc-badge--status',
        notif: 'mc-badge--notif',
      }
      return typeMapping[this.type] || 'mc-badge--button'
    },

    computedStyle() {
      if (this.color) {
        return { backgroundColor: `${this.color} !important` }
      }
      return {}
    },

    computedDotColor() {
      const variantDotMapping = {
        primary: 'dot-primary',
        secondary: 'dot-secondary',
        success: 'dot-success',
        danger: 'dot-danger',
        warning: 'dot-warning',
        info: 'dot-info',
        light: 'dot-light',
        dark: 'dot-dark',
        pink: 'dot-pink',
        purple: 'dot-purple',
        outlinePrimary: 'dot-primary',
        outlineSecondary: 'dot-secondary',
        outlineSuccess: 'dot-success',
        outlineDanger: 'dot-danger',
        outlineWarning: 'dot-warning',
        outlineInfo: 'dot-info',
        outlineDark: 'dot-dark',
        outlinePink: 'dot-pink',
        outlinePurple: 'dot-purple',
        outlinePlain: 'dot-plain',
        outlinePlainSecondary: 'dot-plain',
      }
      return variantDotMapping[this.variant] || 'dot-primary'
    },
  },
}
</script>
